<template>
    <div class="center-box" v-if="show">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "CenterBox",
        props: {
            show: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>
.center-box{
    padding: 1rem;
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 100000;
    transform: translate(-50%, -50%);
}
</style>